/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ScholarshipTypeAttachedPersonViewModel } from "../types/ScholarshipTypeAttachedPersonViewModel.ts";

export const scholarshipTypeAttachedPersonViewModelSchema = z.object({
  studentName: z
    .string()
    .describe("Nome do aluno vinculado à bolsa.")
    .nullish(),
  classStudentName: z
    .string()
    .describe("Descrição da turma do aluno.")
    .nullish(),
  discountPercentage: z
    .number()
    .describe("Percentual de desconto aplicado à matrícula. Opcional.")
    .nullish(),
  enrollmentStatus: z.optional(
    z
      .number()
      .int()
      .describe("Valor numérico do status da matrícula (EEnrollmentStatus)."),
  ),
}) as unknown as ToZod<ScholarshipTypeAttachedPersonViewModel>;
